import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChange
} from '@angular/core';
import { AccordionComponent } from '../accordion.component';

@Component({
  selector: 'vc-accordion-group',
  templateUrl: './accordion-group.component.html',
  styleUrls: ['./accordion-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionGroupComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  heading: string;
  @Input()
  isOpen: boolean;
  @Input()
  index: number;
  @Output()
  change: EventEmitter<any> = new EventEmitter<any>();

  constructor(private accordion: AccordionComponent) {
    this.accordion.addGroup(this);
  }

  ngOnInit() {
    this.change.emit(this.index);
  }

  ngOnDestroy() {
    this.accordion.removeGroup(this);
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        const changedProp = changes[propName];

        if (!changedProp.isFirstChange()) {
          this.accordion.groups[this.index + 1].toggleOpen();
        }
      }
    }
  }

  toggleOpen(): void {
    if (!this.isOpen) {
      this.accordion.closeOthers(this);
      this.isOpen = true;
    } else {
      this.isOpen = false;
    }
    this.change.emit({ index: this.index, isOpen: this.isOpen });
  }
}
